// FilterTag.js

import {
  defineComponent,
  computed,
  inject,
  ref,
  watch,
} from "/Scripts/vue.esm-browser.js";

const html = String.raw;

export default defineComponent({
  name: "FilterTag",
  props: {
    filters: {
      type: Object,
      required: true,
    },
    isSearch: {
      type: Boolean,
      default: false,
    },
  },
  inject: ["filteredDataCount", "groupShowType"],
  emits: ["update:filters", "reset-filters"],
  setup(props, { emit }) {
    const sorts = inject("sorts");
    const nowPage = inject("nowPage");
    const groupShowType = inject("groupShowType");
    const mobileFilterPopup = inject("mobileFilterPopup", ref(false));
    const sortDialogPopup = inject("sortDialogPopup", ref(false));
    const filterCount = inject("filterCount");
    const productStateDialogPopup = inject(
      "productStateDialogPopup",
      ref(false)
    );
    //const activeDayRanges = computed(() => {
    //    return Object.entries(props.filters.dayRanges)
    //        .filter(([_, range]) => range.active) // 僅存取值不需要索引時用_占位
    //        .map(([key, range]) => ({ key, range })); // 重組為物件陣列
    //});
    const activeDayRanges = computed(() => {
      return props.filters.dayRanges
        .filter((range) => range.active) // 只保留 active 為 true 的
        .map((range) => ({ range })); // 若你還有需要加上其他資訊可擴充
    });

    const showPriceRange = computed(() => {
      const [min, max] = props.filters.priceRange;
      const [defaultMin, defaultMax] = props.filters.defaultPriceRange;
      return min !== defaultMin || max !== defaultMax;
    });

    const showDateRange = computed(() => {
      const [start, end] = props.filters.dateRange;
      const [defaultStart, defaultEnd] = props.filters.defaultDateRange;
      return start !== defaultStart || end !== defaultEnd;
    });

    const formatPriceRange = computed(() => {
      const [min, max] = props.filters.priceRange;
      return `${min.toLocaleString()}~${max.toLocaleString()}元`;
    });

    const formatDateRange = computed(() => {
      const [start, end] = props.filters.dateRange;
      return `${start}~${end}`;
    });

    const removePriceRange = () => {
      emit("update:filters", {
        ...props.filters,
        priceRange: [...props.filters.defaultPriceRange],
      });
    };

    const removeDateRange = () => {
      emit("update:filters", {
        ...props.filters,
        dateRange: [...props.filters.defaultDateRange],
      });
    };

    const activeGroupStatus = computed(() => {
      return Object.entries(props.filters.groupStatus)
        .filter(([_, value]) => value) // 僅存取值不需要索引時用_占位
        .map(([key, value]) => {
          switch (key) {
            case "guaranteed":
              return "保證出發";
            case "forming":
              return "即將成團";
            default:
              return;
          }
        }); // 重組為物件陣列
    });
    const weekdays = [
      "星期日",
      "星期一",
      "星期二",
      "星期三",
      "星期四",
      "星期五",
      "星期六",
    ];
    const activeWeekdays = computed(() => {
      return Array.from(props.filters.selectedWeekdays).map(
        (index) => weekdays[index]
      );
    });

    const activeAirlines = computed(() => {
      return Array.from(props.filters.selectedAirlines).map(
        (index) => transService.airlineMap[index]
      );
    });
    const formatDayRange = (range) => {
      if (range.rangeStart === 0) {
        return `${range.rangeEnd}天以下`;
      }
      if (range.rangeEnd === 0) {
        return `${range.rangeStart}天以上`;
      }
      return `${range.rangeStart}~${range.rangeEnd}天`;
    };
    const totalFilterNum = computed(() => {
      let count = 0;
      if (showPriceRange.value) {
        count++;
      }
      if (showDateRange.value) {
        count++;
      }
      count += activeWeekdays.value.length;
      count += activeGroupStatus.value.length;
      count += activeAirlines.value.length;
      count += activeDayRanges.value.length;
      count += props.filters.featureTags.size;

      return count;
    });
    const sortDate = () => {
      if (sorts.value.date.active) {
        sorts.value.date.sort =
          sorts.value.date.sort === "asc" ? "desc" : "asc";
      }
      sorts.value.date.active = true;
      sorts.value.price.active = false;
      sorts.value.day.active = false;
    };
    const sortPrice = () => {
      if (sorts.value.price.active) {
        sorts.value.price.sort =
          sorts.value.price.sort === "asc" ? "desc" : "asc";
      }
      sorts.value.price.active = true;
      sorts.value.date.active = false;
      sorts.value.day.active = false;
    };
    const sortDay = () => {
      if (sorts.value.day.active) {
        sorts.value.day.sort = sorts.value.day.sort === "asc" ? "desc" : "asc";
      }
      sorts.value.day.active = true;
      sorts.value.date.active = false;
      sorts.value.price.active = false;
    };

    const removeWeekday = (weekday) => {
      const index = weekdays.indexOf(weekday);
      const newWeekdays = new Set(props.filters.selectedWeekdays);
      newWeekdays.delete(index);
      emit("update:filters", {
        ...props.filters,
        selectedWeekdays: newWeekdays,
      });
    };

    const removeGroupStatus = (status) => {
      const key = status === "保證出發" ? "guaranteed" : "forming";
      emit("update:filters", {
        ...props.filters,
        groupStatus: {
          ...props.filters.groupStatus,
          [key]: false,
        },
      });
    };

    const removeAirline = (airline) => {
      // 找到要刪除的航空公司的索引
      const indexToRemove = Array.from(props.filters.selectedAirlines).find(
        (index) => transService.airlineMap[index] === airline
      );

      if (indexToRemove !== undefined) {
        const newAirlines = new Set(props.filters.selectedAirlines);
        newAirlines.delete(indexToRemove);
        emit("update:filters", {
          ...props.filters,
          selectedAirlines: newAirlines,
        });
      }
    };

    const removeFeatureTag = (tag) => {
      const newTags = new Set(
        [...props.filters.featureTags].filter((t) => t !== tag)
      );
      emit("update:filters", {
        ...props.filters,
        featureTags: newTags,
      });
    };

    const removeDayRange = (targetRange) => {
      const updatedDayRanges = props.filters.dayRanges.map((range) => {
        if (
          range.rangeStart === targetRange.rangeStart &&
          range.rangeEnd === targetRange.rangeEnd
        ) {
          return { ...range, active: false };
        }
        return range;
      });

      emit("update:filters", {
        ...props.filters,
        dayRanges: updatedDayRanges,
      });
    };
    const resetFilters = () => {
      emit("reset-filters");
    };

    const toggleGroupShowType = () => {
      nowPage.value = 1; //回到第一頁
      groupShowType.value =
        groupShowType.value === "uni" ? "horizontal" : "uni";
    };
    watch(
      () => totalFilterNum.value,
      (newFilters) => {
        filterCount.value = newFilters;
      },
      { deep: true }
    );

    return {
      activeDayRanges,
      formatDayRange,
      activeWeekdays,
      activeAirlines,
      activeGroupStatus,
      sorts,
      sortDate,
      sortPrice,
      sortDay,
      removeWeekday,
      removeGroupStatus,
      removeAirline,
      removeFeatureTag,
      removeDayRange,
      resetFilters,
      showPriceRange,
      formatPriceRange,
      removePriceRange,
      showDateRange,
      formatDateRange,
      removeDateRange,
      toggleGroupShowType,
      mobileFilterPopup,
      sortDialogPopup,
      productStateDialogPopup,
      filterCount,
      totalFilterNum,
    };
  },
  mounted() {
    let filter_tag_list = document.querySelector(
      ".product_wrap .filter_tag_list_box .filter_tag_list"
    );
    if (filter_tag_list) {
      function filterTagDisplay() {
        const labels = Array.from(filter_tag_list.children).filter((label) =>
          label.classList.contains("filter_tag")
        );
        const filter_tag_list_lineNumber = 2; //行數
        const filter_tag_list_gap = 8; //按鈕之間的間隔px

        const wrapWidth =
          document.querySelector(".artical_wrap .filter_tag_list").offsetWidth *
          filter_tag_list_lineNumber;
        const availableWidth =
          wrapWidth -
          filter_tag_list.querySelector(".more_btn").offsetWidth -
          filter_tag_list.querySelector(".tagDelete_btn").offsetWidth -
          filter_tag_list_gap;
        let labelTotalWidth = 0;
        let hasHiddenItems = false;
        labels.forEach((label) => {
          label.style.display = "none";
        });

        // 取得第一行的最右邊filter_tag與filter_tag_list右邊的空隙
        function getRightGap() {
          const labels = Array.from(filter_tag_list.children).filter((label) =>
            label.classList.contains("filter_tag")
          ); // 取得所有 li

          // 取得第一個 label 的 top，作為第一行的基準
          const firstRowTop = labels[0].offsetTop;

          // 篩選出所有第一行的 label
          const firstRowItems = labels.filter(
            (label) => label.offsetTop === firstRowTop
          );

          // 找出第一行最右邊的 label（計算 offsetLeft + offsetWidth）
          let rightMostLi = firstRowItems.reduce((rightMost, label) => {
            return label.offsetLeft + label.offsetWidth >
              rightMost.offsetLeft + rightMost.offsetWidth
              ? label
              : rightMost;
          }, firstRowItems[0]);

          // 計算 List 右邊與最右邊 label 之間的距離
          const ListRightEdge =
            filter_tag_list.offsetLeft + filter_tag_list.offsetWidth;
          const labelRightEdge =
            rightMostLi.offsetLeft + rightMostLi.offsetWidth;
          return ListRightEdge - labelRightEdge;
        }

        for (const label of labels) {
          label.style.display = "";
          labelTotalWidth += label.offsetWidth + filter_tag_list_gap;
          if (labelTotalWidth + getRightGap() > availableWidth) {
            label.style.display = "none";
            hasHiddenItems = true;
          }
        }
        filter_tag_list.querySelector(".more_btn").style.display =
          hasHiddenItems ? "block" : "none";
      }

      if (!filter_tag_list.classList.contains("close")) {
        filter_tag_list.classList.add("close");
      }

      function filterTagDisplayCheck() {
        if (filter_tag_list.classList.contains("close")) {
          filterTagDisplay();
        } else {
          const filter_tags = filter_tag_list.querySelectorAll(".filter_tag");
          filter_tags.forEach((filter_tag) => {
            filter_tag.style.display = "";
          });
        }
      }

      document.addEventListener("DOMContentLoaded", filterTagDisplayCheck());

      const moreBtn = document.querySelector(".more_btn");
      moreBtn.addEventListener("click", function () {
        filter_tag_list.classList.toggle("close");
        filterTagDisplayCheck();
        moreBtn.textContent =
          moreBtn.textContent === "更多..." ? "收合" : "更多...";
      });
      document
        .querySelector(".filter_toggle_btn")
        .addEventListener("click", filterTagDisplayCheck);
      const filterTagObserver = new MutationObserver(() => {
        filterTagDisplayCheck();
      });

      filterTagObserver.observe(filter_tag_list, {
        childList: true,
        subtree: true,
      });

      const filterTagsObserver = new ResizeObserver((entries) => {
        requestAnimationFrame(() => {
          filterTagDisplayCheck();
        });
      });

      filterTagsObserver.observe(filter_tag_list);

      // 監聽螢幕寬度變化
      window.addEventListener("resize", filterTagDisplayCheck);
    }
  },

  template: html`
    <div class="filterTag_block">
      <div v-if="isSearch" class="title_h1">搜尋結果</div>
      <div class="tag_number_box">
        共
        <span class="tag_number">{{ filteredDataCount }}</span>
        款
      </div>
      <div class="filterTag_block_list">
        <div class="filter_tag_list_box">
          <div class="filter_tag_list close">
            <label class="filter_tag" v-if="showPriceRange">
              <span>{{ formatPriceRange }}</span>
              <button class="tag_close" @click="removePriceRange">
                <svg>
                  <use xlink:href="#Com_icon_close"></use>
                </svg>
              </button>
            </label>
            <label class="filter_tag" v-if="showDateRange">
              <span>{{ formatDateRange }}</span>
              <button class="tag_close" @click="removeDateRange">
                <svg>
                  <use xlink:href="#Com_icon_close"></use>
                </svg>
              </button>
            </label>
            <label
              class="filter_tag"
              v-for="weekday in activeWeekdays"
              :key="weekday"
            >
              <span>{{ weekday}}</span>
              <button class="tag_close" @click="removeWeekday(weekday)">
                <svg>
                  <use xlink:href="#Com_icon_close"></use>
                </svg>
              </button>
            </label>
            <label
              class="filter_tag"
              v-for="status in activeGroupStatus"
              :key="status"
            >
              <span>{{ status}}</span>
              <button class="tag_close" @click="removeGroupStatus(status)">
                <svg>
                  <use xlink:href="#Com_icon_close"></use>
                </svg>
              </button>
            </label>
            <label
              class="filter_tag"
              v-for="airline in activeAirlines"
              :key="airline"
            >
              <span>{{ airline}}</span>
              <button class="tag_close" @click="removeAirline(airline)">
                <svg>
                  <use xlink:href="#Com_icon_close"></use>
                </svg>
              </button>
            </label>
            <label
              class="filter_tag"
              v-for="tag in filters.featureTags"
              :key="tag"
            >
              <span>{{ tag}}</span>
              <button class="tag_close" @click="removeFeatureTag(tag)">
                <svg>
                  <use xlink:href="#Com_icon_close"></use>
                </svg>
              </button>
            </label>
            <label
              class="filter_tag"
              v-for="(item, index) in activeDayRanges"
              :key="index"
            >
              <span>{{ formatDayRange(item.range) }}</span>
              <button class="tag_close" @click="removeDayRange(item.range)">
                <svg>
                  <use xlink:href="#Com_icon_close"></use>
                </svg>
              </button>
            </label>
            <button class="more_btn">更多...</button>
            <button class="tagDelete_btn" @click="resetFilters">
              清除全部
            </button>
          </div>
        </div>
      </div>
    </div>
  `,
  methods: {},
});
